import { http } from "../../../config/HttpMethod";
import { JETLIFT_ENDPOINTS } from "../../../store/jetlift/endpoints";

export const getNozzleThroatList = async (payload: string | number) => {
    const params = { id: payload };
    try {
        const response = await http.get(`${JETLIFT_ENDPOINTS.GET_NOZZLE_THROAT_LIST}`, { params });
        return response?.data;
    } catch (err) {
        console.log(err, 'error');
    }
};
    
export const getArea = async (diameter: number) => {
    const payload = {
        diameter,
    }
    try {
        const response = await http.post(`${JETLIFT_ENDPOINTS.GET_AREA}`, payload);
        return response?.data;
    } catch (err) {
        console.log(err, 'error');
    }
};
